<template>
  <div class="footer-form">
    <div class="footer-form-left"></div>
    <div class="footer-form-center">
      <button-component
        typeButton="button"
        type="cancel"
        @click="handleCancel"
        v-if="hasCancel"
      >
        <IconCancel slot="icon" title="Cancelar" />
        Cancelar
      </button-component>

      <button-component
        type="success"
        typeButton="button"
        @click="handleSave"
        v-if="hasSave"
      >
        Salvar
      </button-component>
    </div>
    <div class="footer-form-right">
      <button-component
        type="primary"
        typeButton="button"
        @click="handleClone"
        v-if="isClone"
      >
        Clonar
      </button-component>
    </div>
  </div>
</template>

<script>
import IconCancel from 'vue-material-design-icons/Close';

import ButtonComponent from './Button';

export default {
  name: 'FooterForm',
  components: {
    ButtonComponent,
    IconCancel,
  },
  props: {
    hasSave: {
      type: Boolean,
      default: true,
    },
    hasCancel: {
      type: Boolean,
      default: true,
    },
    isClone: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    handleCancel(e) {
      this.$emit('cancel', e);
    },
    handleSave(e) {
      this.$emit('submit', e);
    },
    handleClone(e) {
      this.$emit('clone', e);
    },
  },
};
</script>
